import { FaInstagram, FaFacebookF } from "react-icons/fa";
import PlaceholderImage from "./PlaceholderImage";
import "./TrainerCard.css";

export default function TrainerCard({ trainer, onOpen }) {
  return (
    <article className="trainer-card">
      <div className="trainer-card__media">
        <PlaceholderImage tone="3" alt={`${trainer.name}, ${trainer.specialty} coach`} ratio="3/4" />
      </div>
      <div className="trainer-card__body">
        <p className="trainer-card__specialty">{trainer.specialty}</p>
        <h3 className="trainer-card__name">{trainer.name}</h3>
        <p className="trainer-card__meta">{trainer.qualification} · {trainer.experience}</p>
        <div className="trainer-card__row">
          <button type="button" className="btn-ghost" onClick={() => onOpen(trainer)}>
            View Profile
          </button>
          <div className="trainer-card__social">
            <a href={trainer.social.instagram} aria-label={`${trainer.name} on Instagram`}><FaInstagram aria-hidden="true" /></a>
            <a href={trainer.social.facebook} aria-label={`${trainer.name} on Facebook`}><FaFacebookF aria-hidden="true" /></a>
          </div>
        </div>
      </div>
    </article>
  );
}
